import { colors, Typography } from "@mui/material";

const colorConfigs = {
  sidebar: {
    background: "linear-gradient(180deg, #1b3a5e 90px, #1173b7 95%)",
    color: "#eeeeee",
    hoverBg: "rgb(49, 80, 116)",
    activeBg: "#1e253a"
  },
  topbar: {
    bg: "linear-gradient(-270deg, #1b3a5e -350px, #1173b7 100vw)",  // Updated gradient with provided colors
    color: "#ffff",
  },
  mainBg: colors.grey["100"]
};

export default colorConfigs;
